
import { Component, Vue } from "vue-property-decorator"
import { State, Getter } from "vuex-class"

import ZendeskHelp from "@/components/ZendeskHelp.vue"

import { BaseState } from "@/store"
import { CurrentUser } from "@/types/user"
import { TenantFeatures } from "@/types/tenantFeatures"

	@Component({
		components: {
			"zendesk-help": ZendeskHelp
		}
	})
export default class SideBar extends Vue {
		@State((state: BaseState) => state.me) private readonly me!: CurrentUser;

		@Getter getIsFeatureEnabled!: (feature: TenantFeatures) => boolean
		@Getter("getRecordName") private readonly recordName!: string;
		@Getter("getHasIntegrations") private readonly hasIntegrations!: boolean;

		domainName: string = this.getDomainName()
		domainLogoFailed: boolean = false
		domainLogoLoaded: boolean = false

		private getDomainName (): string {
			let domainName = location.pathname.replace(/\//g, "")
			if (!domainName || domainName.length === 0) {
				return "default"
			}

			return domainName
		}

		get domainLogoUrl (): string | null {
			if (this.domainName.length > 0 && !this.domainLogoFailed) {
				return `${process.env.VUE_APP_HTTP_API_URI}tenant/logo/${this.domainName}`
			}
			return null
		}

		get logoAltText (): string {
			if (this.domainName.length > 0 && !this.domainLogoFailed) {
				return "Logo"
			}
			return "SureView Cases Logo"
		}

		get domainLogoInSidebarFeatureIsEnabled (): boolean {
			return this.getIsFeatureEnabled(TenantFeatures.DomainLogoInSidebar)
		}

		// This will trigger before the router-link
		logoClicked () {
			// When we're on the dashboard navigate away so that the router-link will take us back to the dashboard and load the default dash
			if (this.$router.currentRoute.name === "dashboard") {
				this.$router.push({ name: "/" })
			}
		}
}
